import React from 'react';
import WrapperValidationInputGroup from "./WrapperValidationInputGroup";
import PropTypes from "prop-types";
import {RequiredValidator} from "../../validator/RequiredValidators";
import {ExactLengthValidator} from "../../validator/LengthValidators";
import {MaskInputGroup} from "../base/MaskInputGroup";
import {DateValidator} from "../../validator/DateValidator";

class DateInput extends React.Component {
    render() {
        return (
            <MaskInputGroup autoFocus={this.props.autoFocus} input={this.props.input} mask="00/00/0000"
                            alert={this.props.alert} onChange={this.props.onChange} onBlur={this.props.onBlur}/>
        )
    }
}

let listValidators = () => {
    let validators = [];
    validators.push(new RequiredValidator());
    validators.push(new ExactLengthValidator("", 8));
    validators.push(new DateValidator(""));
    return validators;
};

const validators = {
    validators: listValidators(),
};

export const DateInputGroup = WrapperValidationInputGroup(DateInput, validators);

DateInputGroup.propTypes = {
    alert: PropTypes.shape({
        show: PropTypes.bool.isRequired,
        title: PropTypes.string,
        text: PropTypes.string,
        type: PropTypes.string,
        dismissible: PropTypes.bool,
        handleMessage: PropTypes.func
    }),
    input: PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.string,
        disabled: PropTypes.bool,
        type: PropTypes.string,
        placeholder: PropTypes.string,
        required: PropTypes.bool,
        title: PropTypes.string,
    }).isRequired,
    validateOn: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
};


// WEBPACK FOOTER //
// ./src/input/validation/DateInputGroup.js